import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormService } from 'src/app/services/form.service';

@Component({
    selector: 'app-book-demo-dialog',
    templateUrl: './book-demo-dialog.component.html',
    styleUrls: ['./book-demo-dialog.component.scss']
})
export class BookDemoDialogComponent implements OnInit {
    formGroup: FormGroup;
    interestList: string[] = [
        'Interactive Flat Panel',
        'K-12 Digital Content',
        'LMS (Learning Management System)',
        'IFP Protection (Shutter)',
        'All in One PC',
        'Others'
    ];

    constructor(
        private formBuilder: FormBuilder,
        private dialogRef: MatDialogRef<BookDemoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private formService: FormService,
        private snackBar: MatSnackBar
    ) {
        this.formGroup = this.formBuilder.group({
            name: ['', [Validators.required, Validators.minLength(3)]],
            mobile: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
            email: ['', [Validators.required, Validators.email]],
            interest: ['', Validators.required],
            message: ['']
        });
    }

    ngOnInit(): void { }

    submit(): void {
        if (this.formGroup.valid) {
            // Mock submission or usage of existing service
            // Assuming we can use contactUs or similar, or just log for now if specific endpoint isn't ready
            // Based on ContactUs implementation, we might need a specific structure

            const formData = {
                name: this.formGroup.value.name,
                mobile: this.formGroup.value.mobile,
                email: this.formGroup.value.email,
                genre: this.formGroup.value.interest, // Mapping interest to genre/related field
                message: `Schedule a Demo Request. Interest: ${this.formGroup.value.interest}. Message: ${this.formGroup.value.message}`
            };

            // Using contactUs service as a fallback/placeholder since we don't have a specific bookDemo endpoint yet
            // Ideally, there should be a separate method. 
            // For now, I will use the contactUs method as per the plan to "reuse logic" or just console log if I shouldn't spam real API.
            // But user asked to "create a form", implying function. I'll use logic similar to `ContactUs` method in `ContactUsComponent`.

            this.formService.contactUs(formData).subscribe(
                (res: any) => {
                    if (res.error === false) {
                        this.snackBar.open(res.message || 'Request Submitted Successfully', 'Ok', { duration: 4000 });
                        this.dialogRef.close(true);
                    } else {
                        this.snackBar.open(res.message || 'Submission failed', 'Ok', { duration: 4000 });
                    }
                },
                (error) => {
                    console.error('Error:', error);
                    this.snackBar.open('An error occurred. Please try again.', 'Ok', { duration: 4000 });
                }
            );
        } else {
            this.formGroup.markAllAsTouched();
        }
    }

    close(): void {
        this.dialogRef.close();
    }
}
